import { Autocomplete, Box, Button, Chip, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { ButtonLoader } from '../../../shared_elements/components';
import { addReportAnIssueApi, getDropDwonOptionApi } from './apiServices';
import { checkApiStatus } from '../../../utils';
import { globalBetaPostService } from '../../../utils/globalApiServices';
import { enqueueSnackbar } from 'notistack';
import appConfig from '../../../config';
import { useDropzone } from 'react-dropzone';
import { trackActivity } from '../../../utils/mixpanel';

const ReportAnIssue = ({ onToggleModal }) => {
  const [dropdownMenu, setDropDownMenu] = useState()
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState({});
  const [data, setData] = useState({})
  const [attachments, setAttachments] = useState([]);
  const SUPPORTED_EXTENSIONS = [".jpg", ".jpeg", ".png"];


  useEffect(() => {
    getDropDownList('skeletonLoader', { per_page: 20 });
    trackActivity('Page Viewed', { page_title: 'Report An Issue' });
  }, []);

  const handleItemClicked = (page_type) => {
    trackActivity('Item Clicked', { page_title: 'Report An Issue', page_type: page_type });
  };

  const getDropDownList = (loaderType, query = {}) => {
    setLoading(true);
    const payload = { constant_types: ["bug_module", "bug_severity", "bug_classification"] };
    globalBetaPostService(getDropDwonOptionApi(), payload).then(response => {
      if (checkApiStatus(response)) {
        setLoading(false);
        setDropDownMenu(response.data?.data);
      } else {
        setLoading(false);
      }
    })
  };

  const onRestErrorKey = (key) => {
    setError((prev) => ({ ...prev, [key]: '' }));
  };

  const onFieldChange = (key, value) => {
    setData({ ...data, [key]: value });
    setError((prev) => ({ ...prev, [key]: '' }));
  };

  const onSubmitReportAnIssue = () => {
    const validationInputs = {
      title: data?.title ? "" : "Please enter Title",
      module: data?.module ? "" : "Please Select Module",
      severity: data?.severity ? "" : "Please Select Severity",
      classification: data?.classification ? "" : "Please Select Classification"
    };
    if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
      setLoading(true);
      let formData = new FormData();
      if (attachments?.length) {
        attachments.forEach(file => {
          formData.append("attachments", file);
        });
      }
      formData.append("title", data.title);
      if(data?.description) formData.append("description", data.description);
      formData.append("current_page_url", appConfig.domain.subDomian);
      formData.append("module", JSON.stringify(data.module?.value));
      formData.append("severity", JSON.stringify(data.severity?.value));
      formData.append("classification", JSON.stringify(data.classification?.value));
      globalBetaPostService(addReportAnIssueApi(), formData, { "Content-Type": "multipart/form-data" }).then(async (response) => {
        if (checkApiStatus(response)) {
          enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
          trackActivity('Item Added', { page_title: 'Report An Issue', success_msg: response?.data?.message, payload: data, response: response?.data });
          onToggleModal()
          setLoading(false);
        } else {
          setLoading(false);
          enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
          trackActivity('Item Added', { page_title: 'Report An Issue', error_msg: response?.data?.message, payload: data, response: response?.data });
        }
      });
    } else {
      setError(validationInputs);
      trackActivity('Item Added', { page_title: 'Report An Issue', error_msg: validationInputs });
    }
  }
  const onDrop = (acceptedFiles, rejectedFiles) => {
    const newFiles = [];
    setError({});
    for (let file of acceptedFiles) {
      const ext = "." + file.name.split(".").pop().toLowerCase();

      if (!SUPPORTED_EXTENSIONS.includes(ext)) {
        setError({...error,attachments:`File type ${ext} not supported.`});
        continue;
      }
      if (attachments?.find(oldAttachment => oldAttachment?.name === file?.name)) {
        enqueueSnackbar(`${file?.name} is already exists`, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" } });
        continue;
      }
      newFiles.push(file);
    }
    const updatedFiles = [...attachments, ...newFiles];
    setAttachments(updatedFiles);
    if (rejectedFiles.length) {
      setError({...error,attachments:"Some files were rejected. Please check type/size."});
    }
  };

  const removeFile = (file) => {
    const updatedFiles = attachments.filter((f) => f.name !== file?.name);
    setAttachments(updatedFiles);
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: true,
    accept: {
      "image/jpeg": [".jpg", ".jpeg"],
      "image/png": [".png"],
    },
  });


  return (
    <>
      <Dialog
        onClose={(event, reason) => {
          if (reason !== 'backdropClick') {
            onToggleModal();
          }
        }}
        disableEscapeKeyDown
        aria-labelledby="customized-dialog-title"
        className="add-lease-dialog"
        maxWidth={false}
        slotProps={{ paper: { sx: { width: '100%', maxWidth: '1050px', m: 'auto', } } }}
        open={true}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} className='dialog-header'>
          <Typography fontSize={"1.5rem"} sx={{marginLeft: "15px"}}>Report An Issue</Typography>
          <Typography sx={{ fontSize: "15px", lineHeight: 1.6, marginLeft: "15px" }}>Please report only technical issues / bugs encountered while operating the SPARTA system. Issue will be reported to SPARTA IT team for action.</Typography>
        </DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2} m={1}>
            <Grid size={{ md: 12, xs: 12 }}>
              <TextField
                // disabled={addEditSupplement.mode === "view"}
                id="title"
                label="Title"
                required
                variant="outlined"
                size="small"
                margin="normal"
                readOnly={true}
                slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 255 } }}
                value={data?.title || ""}
                onChange={(e) => onFieldChange("title", e.target?.value)}
                onFocus={() => onRestErrorKey("title")}
                error={Boolean(error?.title)}
                helperText={error?.title}
                fullWidth
              />
            </Grid>
            <Grid size={{ md: 4, xs: 12 }}>
              <Autocomplete
                disablePortal
                disableClearable
                options={dropdownMenu?.filter(item => item.type === "bug_module").map(({ value, label }) => ({ value, label })) || []}
                getOptionLabel={(option) => option?.label || ""}
                isOptionEqualToValue={(option,val)=> option?.value===val?.value}
                noOptionsText={isLoading ? "Loading..." : "No Option Available"}
                value={ data?.module || null}
                onChange={(e, value) => { onFieldChange("module", value) }}
                onFocus={() => onRestErrorKey("module")}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Module"
                    margin='normal'
                    size='small'
                    required
                    error={Boolean(error?.module)}
                    helperText={error?.module}
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                      input: {
                        ...params?.InputProps, endAdornment: (<>{isLoading ? (<CircularProgress color="inherit" size={20} />) : null}
                          {params?.InputProps?.endAdornment}
                        </>
                        )
                      }
                    }}
                  />
                )}
              />
            </Grid>
            <Grid size={{ md: 4, xs: 12 }}>
              <Autocomplete
                disablePortal
                disableClearable
                options={dropdownMenu?.filter(item => item.type === "bug_severity").map(({ value, label }) => ({ value, label })) || []}
                getOptionLabel={(option) => option?.label || ""}
                isOptionEqualToValue={(option,val)=> option?.value===val?.value}
                noOptionsText={isLoading? "Loading..." : "No Option Available"}
                value={ data?.severity || null}
                onChange={(e, value) => { onFieldChange("severity", value) }}
                onFocus={() => onRestErrorKey("severity")}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Severity"
                    margin='normal'
                    size='small'
                    required
                    error={Boolean(error?.severity)}
                    helperText={error?.severity}
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                      input: {
                        ...params?.InputProps, endAdornment: (<>{isLoading ? (<CircularProgress color="inherit" size={20} />) : null}
                          {params?.InputProps?.endAdornment}
                        </>
                        )
                      }
                    }}
                  />
                )}
              />
            </Grid>
            <Grid size={{ md: 4, xs: 12 }}>
              <Autocomplete
                disablePortal
                disableClearable
                options={dropdownMenu?.filter(item => item.type === "bug_classification").map(({ value, label }) => ({ value, label })) || []}
                getOptionLabel={(option) => option?.label || ""}
                isOptionEqualToValue={(option,val)=> option?.value===val?.value}
                noOptionsText={isLoading ? "Loading..." : "No Option Available"}
                value={data?.classification || null}
                onChange={(e, value) => { onFieldChange("classification", value) }}
                onFocus={() => onRestErrorKey("classification")}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Classification"
                    margin='normal'
                    size='small'
                    required
                    error={Boolean(error?.classification)}
                    helperText={error?.classification}
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                      input: {
                        ...params?.InputProps, endAdornment: (<>{isLoading ? (<CircularProgress color="inherit" size={20} />) : null}
                          {params?.InputProps?.endAdornment}
                        </>
                        )
                      }
                    }}
                  />
                )}
              />
            </Grid>
            <Grid size={{ md: 12, xs: 12 }}>
              <TextField
                // disabled={addEditSupplement.mode === "view"}
                id="description"
                label="Description"
                variant="outlined"
                readOnly={true}
                size="small"
                margin="normal"
                slotProps={{ inputLabel: { shrink: true } }}
                value={data?.description || ""}
                onChange={(e) => { { onFieldChange("description", e.target.value); } }}
                fullWidth
                multiline
                rows={3}
              />
            </Grid>
            <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 3 }}>
              <Box>
                <Box
                  {...getRootProps()}
                  sx={{
                    border: "2px dashed #ccc",
                    borderRadius: "8px",
                    p: 3,
                    textAlign: "center",
                    cursor: "pointer",
                    backgroundColor: isDragActive ? "#f0f0f0" : "#fafafa",
                  }}
                >
                  <input {...getInputProps()} />
                  <Typography style={{ fontSize: "13px" }}>
                    {"Drag and drop, or click here to upload Screenshot(s)"}
                  </Typography>
                </Box>
                {error?.attachments && (
                  <Typography color="error" style={{ fontSize: "12px", marginTop: "5px" }}>
                    {error?.attachments}
                  </Typography>
                )}
                {attachments?.length > 0 && (
                  <Box sx={{ mt: 2 }}>
                    <Typography variant="body2">Preview:</Typography>
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1 }}>
                      {attachments.map((file, index) => (
                        <Chip
                          key={index}
                          label={file?.name}
                          onDelete={() => removeFile(file)}
                          variant="outlined"
                        />
                      ))}
                    </Box>
                  </Box>
                )}
                <Typography
                  style={{ fontSize: "11px", background: "#ffff96", marginTop: "8px", display: "inline-block" }}
                >
                  {/* Note : Supported extension (.pdf,.doc,.docx,.xls,.xlsx,.txt,.jpg,.jpeg,.png), max upto 2.5 GB. */}
                  Note : Supported extension ({SUPPORTED_EXTENSIONS?.join(", ")}).
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{marginRight: "20px"}}>
          <Button className="cancel-btn" disableRipple disabled={isLoading} variant="outlined" size="small" onClick={() => { onToggleModal(); handleItemClicked('Cancel Button'); }}> Cancel</Button>
          <Button variant="contained" size="small" className="btn-primary" onClick={() => { onSubmitReportAnIssue(); handleItemClicked('Save Button'); }}> {isLoading ? <ButtonLoader /> : "SAVE"}</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default ReportAnIssue